import { render, staticRenderFns } from "./EntityListLayout.vue?vue&type=template&id=7c896908&"
import script from "./EntityListLayout.vue?vue&type=script&lang=js&"
export * from "./EntityListLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c896908')) {
      api.createRecord('7c896908', component.options)
    } else {
      api.reload('7c896908', component.options)
    }
    module.hot.accept("./EntityListLayout.vue?vue&type=template&id=7c896908&", function () {
      api.rerender('7c896908', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/atoms/EntityListLayout.vue"
export default component.exports